import { notification } from 'antd'
import { calculateFilters } from '@utils/filters'
import Link from '@organisms/Link'
import { ThemeProvider } from '@emotion/react'
import { Routes } from '@enums/Routes'
import theme from '../theme'

export const createDownloadReportQuery =
  (options: { url: string; method?: string; body?: any }) =>
  (params?: Record<string, Record<string, unknown>>) => {
    const result: any = {
      ...options,
      headers: {
        'Content-Type': 'application/json',
      },
      responseHandler: (response: Response) => {
        if (response && response.status === 200) {
          notification.success({
            onClick: () => window.location.assign(Routes.REPORTS),
            message: (
              <ThemeProvider theme={theme}>
                Отчёт появится в разделе{' '}
                <Link text="“Отчёты”" route={Routes.REPORTS} asSpan />. По
                готовности, вам придёт уведомление.
              </ThemeProvider>
            ),
          })
        } else {
          notification.error({
            message: 'Произошла ошибка при скачивании отчета.',
          })
        }

        return response.blob()
      },
    }

    if (!params) {
      return result
    }

    if (!options.method || options.method === 'GET') {
      result.params = calculateFilters(params)
    } else {
      result.body = calculateFilters(params)
    }

    return result
  }
